import React from "react";
import CustomerProfileView from "../views/CustomerProfileView";

const CustomerProfile: React.FC = () => {
    return <div style={{ maxWidth: 450 }}>
        <CustomerProfileView />
    </div>;
};

export default CustomerProfile;